import {Grid, Button} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import paths from '../../routes/paths'

const HandleSafeSpace = () => {
  const navigate = useNavigate()
  const handleStartNewConversation = () => {
    navigate(paths.selectStaff)
  }
  return (
    <Grid container justifyContent="center">
      <Grid item lg={9} md={10} sm={10} xs={12}>
        <div className="welcome">
          <h1>Sorry to hear you are not feeling good today 😔.</h1>
          <h2>
            {' '}
            Do you want to use safe space to send a message to a member of staff
            so that they can try and help?
          </h2>
          <Button onClick={handleStartNewConversation} disableElevation className="start-button">
            Start New Conversation
          </Button>
        </div>
      </Grid>
    </Grid>
  )
}
export default function submissionBlocker({type}) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <div className="welcome">
          <h1>
            {type === 'closed' ? (
              'This survey is closed'
            ) : type === 'end' ? (
              <div>
                <p>Congratulations!</p>You have completed the survey 🎉
              </div>
            ) : type === 'safeSpace' ? (
              <HandleSafeSpace />
            ) : (
              'You have already submitted this survey'
            )}
          </h1>
        </div>
      </Grid>
    </Grid>
  )
}
